import Request from "@/shared/utils/_request";
class Cash {
  constructor() { }
  /**
   * 人脉变现列表
   * @param {*} payload
   */
  getRelationList(payload) {
    return Request.post("/clue/candidate-clue/get-list", payload);
  }
  /**
   * 职位变现列表
   * @param {*} payload
   */
  getJobList(payload) {
    return Request.post("/clue/job-clue/get-list", payload);
  }
  //指派BD
  changeBd(payload) {
    return Request.post("/clue/job-clue/setBdCharge", payload);
  }
  //职位沟通最新结果
  getJobCommunication(payload) {
    return Request.post("/clue/JobClueCommunication/getNewest", payload);
  }
  //沟通人脉变现
  checkRelationStatus(payload) {
    return Request.post("/clue/CandidateClue/change-status", payload);
  }
  //沟通职位变现
  checkJobStatus(payload) {
    return Request.post("/clue/JobClueCommunication/create", payload);
  }
  /**
   * 职位变现沟通记录
   * @param {{job_clue_id}} payload
   */
  JobCommunicationList(payload) {
    return Request.post("/clue/JobClueCommunication/get-all", payload);
  }

  // 获取变现类型
  getClueTypes() {
    return Request.post("/clue/job-clue/get-types");
  }
}

export const cash = new Cash();
